import { useState, useEffect } from 'react';

const useIsMobileView = () => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 991);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 991);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobileView;
};

export default useIsMobileView;
